:host([isDisabled]) {
  gz-dropdown {
    pointer-events: none;
    opacity: 0.5;
  }
}

.grid-pagination {
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--grid-pagination-height, 100%);
  border-left: 1px solid var(--grid-border-color);
}

.items-per-page {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 calc(var(--spacer) * 2);
  color: var(--body-text-arrows-400);

  span {
    display: block;
    padding-right: calc(var(--spacer) * 1.5);
    font-size: var(--body-size);
    white-space: nowrap;
  }

  --form-field-input-width: 80px;

  gz-dropdown {
    height: auto;
    width: 80px;
  }
}

.navigation {
  display: flex;
  align-items: center;
  height: 100%;

  .nav-item {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 calc(var(--spacer) * 1.75);
    cursor: pointer;
    border: none;
    border-right: 1px solid var(--grid-border-color);
    background: transparent;
    outline: none;
    &:focus-visible {
      outline: var(--blue-layout-500-focus) 1px solid;
    }

    &:first-child {
      border-left: 1px solid var(--grid-border-color);
    }
  }
}

.navigating-by-page {
  padding-left: calc(var(--spacer) * 2);
  display: flex;
  align-items: center;
  height: 100%;

  --form-field-input-width: 60px;

  gz-dropdown {
    height: auto;
    width: 60px;
  }

  span {
    padding-left: calc(var(--spacer) * 1.5);
    font-size: var(--body-size);
    white-space: nowrap;
    color: var(--body-text-arrows-400);
  }
}
